import { create } from 'zustand';
import { getDataAPI, postDataAPI } from '../Helpers/FetchAPI/index.js';
import { queryClient } from '../lib/store.js';
import { logger } from '../utils/logger.js';

export const addressInit = {
  name: '',
  address: '',
  address2: '',
  city: '',
  state: '',
  zip: '',
  country: ''
};

const useStore = create((set, get) => ({
  initialized: false,
  token: null,
  user: null,
  isAuthenticated: false,
  billingAddress: { ...addressInit },
  shippingAddress: { ...addressInit },
  verifiedBilling: false,
  verifiedShipping: false,


  setToken: (token) => {
    set({ token, isAuthenticated: true });
  },

  fetchUser: async () => {
    const cachedUser = queryClient.getQueryData('authenticatedUser'); // Check if user data is already cached
    if (cachedUser) {
      get().setUser(cachedUser);
      return cachedUser;
    } else {
      try {
        const res = await getDataAPI('/user/profile');
        const user = res.data;
        get().setUser(user);
        queryClient.setQueryData('authenticatedUser', user);

        return user;
      } catch (error) {
        logger.error('Error getting user: %s', error);
      }
    }
  },

  setUser: (user) => {
    set({ user, initialized: true });
  },

  setBillingAddress: (address) => {
    set({ billingAddress: address });
    if (address?.shippoId) {
      get().setVerifiedBilling(true);
    }
  },
  setShippingAddress: (address) => {
    set({ shippingAddress: address });
    if (address?.shippoId) {
      get().setVerifiedShipping(true);
    }
  },
  setVerifiedBilling: (verified) => set({ verifiedBilling: verified }),
  setVerifiedShipping: (verified) => set({ verifiedShipping: verified })
}));

export default useStore;
